import _ from '@strings'
import Inner from '@components/Ui/Inner'
import Text from '@components/Ui/Text'
import Spacer from '@components/Ui/Spacer'
import styles from './Header.scss'

const Header = () => (
  <Inner className={styles.base} classNameOuter={styles.outer}>
    <Text as="h1" type="slab_xl_bold">
      {_('general.headline')}
    </Text>
    <Spacer vertical scale="1" />
  </Inner>
)

Header.defaultProps = {}
Header.propTypes = {}

export default Header
